import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Container, Box, Card, CardActionArea, CardMedia, CardContent,
  Typography, CircularProgress, Alert,
} from '@mui/material'
import { fetchCatalog } from '../api/catalogClient'
import Markdown from '../components/Markdown'

export default function CatalogPage() {
  const [products, setProducts] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchCatalog()
      .then(setProducts)
      .catch(() => setError('Не вдалося завантажити каталог. Спробуйте пізніше.'))
  }, [])

  if (error) {
    return <Container sx={{ py: 4 }}><Alert severity="error">{error}</Alert></Container>
  }

  if (!products) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {products.length === 0 ? (
        <Typography color="text.secondary">Наразі немає доступних продуктів.</Typography>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gap: 3,
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
          }}
        >
          {products.map((product) => (
            <Card key={product.id} sx={{ height: '100%' }}>
              <CardActionArea
                component={Link}
                to={`/${product.slug}`}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  justifyContent: 'flex-start',
                }}
              >
                {product.image_url && (
                  <CardMedia
                    component="img"
                    image={product.image_url}
                    alt={product.name}
                    sx={{ aspectRatio: '16 / 9', objectFit: 'cover' }}
                  />
                )}
                <CardContent>
                  <Typography variant="h6">{product.name}</Typography>
                  {product.description && (
                    <Markdown
                      disableLinks
                      sx={{ mt: 1, color: 'text.secondary', fontSize: '0.875rem' }}
                    >
                      {product.description}
                    </Markdown>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      )}
    </Container>
  )
}
